module.exports = __webpack_public_path__ + "img/logo_new.b42cfd55.png";